var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgMasterCard = function SvgMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 402.3c0 16.7-13.5 30.3-30.3 30.3H30.3C13.6 432.5 0 419 0 402.3V109.7C0 93 13.6 79.5 30.3 79.5h451.5c16.7 0 30.3 13.6 30.3 30.3l-.1 292.5z",
    fill: "#0099df"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 402.3V109.7c0-16.7 13.6-30.3 30.3-30.3H30.3C13.6 79.5 0 93 0 109.7v292.6c0 16.7 13.6 30.3 30.3 30.3h21.5c-16.7-.1-30.3-13.6-30.3-30.3z",
    opacity: 0.15,
    fill: "#202121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M214.5 256c0-34.5 15.9-65.3 40.8-85.5-18.9-15.3-43-24.5-69.3-24.5-60.8 0-110 49.3-110 110 0 60.8 49.3 110 110 110 26.2 0 50.3-9.2 69.3-24.5-24.9-20.2-40.8-51-40.8-85.5z",
    fill: "#ea001b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.5 146c-26.2 0-50.3 9.2-69.3 24.5 24.9 20.2 40.8 51 40.8 85.5s-15.9 65.3-40.8 85.5c18.9 15.3 43 24.5 69.3 24.5 60.8 0 110-49.3 110-110 .1-60.8-49.2-110-110-110z",
    fill: "#f79f1a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.1 256c0-34.5-15.9-65.3-40.8-85.5-24.9 20.2-40.8 51-40.8 85.5s15.9 65.3 40.8 85.5c24.9-20.2 40.8-51 40.8-85.5z",
    fill: "#ff5f01"
  })));
};

export default SvgMasterCard;